import type { ReactNode } from 'react';

/** A cell value, or the muted dash for an unset one. */
export const orDash = (value: unknown): ReactNode =>
  value === undefined || value === null || value === '' ? (
    <span className="text-gray-400 dark:text-gray-500">—</span>
  ) : (
    String(value)
  );
